import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Paper": Paper, "@mui/material/InputBase": InputBase, "@mui/material/Divider": Divider, "@mui/material/IconButton": IconButton, "@mui/icons-material/Menu": MenuIcon, "@mui/icons-material/Search": SearchIcon, "@mui/icons-material/Directions": DirectionsIcon } } });
export default ClientProvider;
